import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

const EditSubscriptionForm = ({openModal, userData, lastInvoiceData}) => {

  const resubscribeStatuses = ['CANCELLED', 'EXPIRED', 'FAILED'];

  return (
    <div className='d-flex flex-column justify-content-between' style={{height: "100%"}}>
      <h4>Manage Subscription</h4>
      <div className='mb-2'>
        <p className='m-0'>{userData.subscriptionTier}</p>
        {lastInvoiceData && (
          <p className='m-0' style={{fontSize: "12px"}}>Last payment: ${lastInvoiceData?.paymentAmount || "0.00"} on {lastInvoiceData?.createdDate.split("T")[0] || "N/A"}</p>
        )}
      </div>
      <div className='d-flex mb-2'>
        <p className='m-0'>Invoice History</p>
        <FontAwesomeIcon
          icon={faChevronRight}
          style={{ cursor: "pointer", color: "#AEAFBA", marginLeft: "auto" }}
          onClick={() => openModal('invoices')}
        />
      </div>
      <div className='d-flex mb-2'>
        <div>
          <p className='m-0' style={{fontSize: "14px"}}>Payment Method</p>
          <p className='m-0'>PayPal</p>
        </div>
        <FontAwesomeIcon
          icon={faChevronRight}
          style={{ cursor: "pointer", color: "#AEAFBA", marginLeft: "auto" }}
          onClick={() => openModal('paymentMethod')}
        />
      </div>

      {/* Subscribe or Cancel option based on user subscription status */}
      <div style={{cursor: "pointer", marginTop: "auto"}}>
        {userData.subscriptionStatus && resubscribeStatuses.includes(userData.subscriptionStatus) ? (
          <p className='m-0' style={{color: "#FFCC19", fontWeight: 300}}>Subscribe</p>
        ) : (userData.subscriptionStatus && userData.subscriptionStatus === 'COMPLETED' ? (
          <p className='m-0' style={{color: "#FFCC19", fontWeight: 300}} onClick={() => openModal('cancelSubscription')}>Cancel Subscription</p>
        ) : (
          null
        ))}

      </div>
    </div>
  )
}

export default EditSubscriptionForm